import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";


import { FormsModule } from "@angular/forms";
import { ResultRanglistListItemComponent } from "src/components/result-ranglist-list-item/result-ranglist-list-item";
import { CategoryNamePipe } from "src/pipes/category-name/category-name";
import { TransDatePipe } from "src/pipes/trans-date/trans-date";
import { PlanTypePipe } from "src/pages/apps/gamer/pipes/plan-type/plan-type";
import { TrophyComponent } from "src/components/trophy/trophy";
import { TrophyCustomComponent } from "src/components/trophy-custom/trophy-custom";
import { CountdownComponent } from "src/components/show-modal/show-modal";
import { ScoreBoardName } from "src/components/scoreboard-by-name/scoreboard-by-name";
import { ScoreBoardBib } from "src/components/scoreboard-bib/scoreboard-bib";
import { ScoreBoardWallen } from "src/components/score-board-wallen/score-board-wallen";
import { ScoreBoardModal } from "src/components/score-board-modal/score-board-modal";
import { ScoreBoardEinzel } from "src/components/score-board-einzel/score-board-einzel";
import { ResultSearchListItemComponent } from "src/components/result-search-list-item/result-search-list-item";
import { ResultMenuToolbarComponent } from "src/components/result-menu-toolbar/result-menu-toolbar";
import { RaceByName } from "src/components/race-by-name-component/race-by-name";
import { RaceByBib } from "src/components/race-by-bib-component/race-by-bib";
import { PopupRegistrationComponent } from "src/components/popup-registration/popup-registration";
import { PopoverFeedComponent } from "src/components/popover-feed/popover-feed";
import { PaymentComponent } from "src/components/payment/payment.component";
import { ParticipantListComponent } from "src/components/participant-list/participant-list";
import { MysportSportartListItemComponent } from "src/components/mysport-sportart-list-item/mysport-sportart-list-item";
import { MysportProfileListItemComponent } from "src/components/mysport-profile-list-item/mysport-profile-list-item";
import { MysportIconComponent } from "src/components/mysport-icon/mysport-icon";
import { MyRoutesComponent } from "src/components/my-routes/my-routes-component";
import { MyEventListItemComponent } from "src/components/my-event-list-item/my-event-list-item";
import { ModalConfigureGeoComponent } from "src/components/modal-configure-geo/modal-configure-geo";
import { MenuLayerTotalComponent } from "src/components/menu-layer-total/menu-layer-total";
import { MenuLayerCategoryComponent } from "src/components/menu-layer-category/menu-layer-category";
import { LeaderActivity } from "src/components/leader-activity/leader-activity";
import { ImageContainerComponent } from "src/components/image-container/image-container";
import { GoogleMapsComponent } from "src/components/google-maps/google-maps";
import { GoogleAdsComponent } from "src/components/google-ads/google-ads";
import { EventsBlockWithContainersComponent } from "src/components/events-block-with-containers/events-block-with-containers";
import { EventSearchListItemComponent } from "src/components/event-search-list-item/event-search-list-item";
import { ContainersWithItemsComponent } from "src/components/container-with-items/container-with-items";
import { LineChartComponent } from "src/components/chart/line-chart";
import { BibNumberComponent } from "src/components/bib-number/bib-number";
import { IonicModule } from "@ionic/angular";
import { CreateTeamComponent } from "src/pages/apps/lineup/components/create-team/create-team";
import { CreatePlayerComponent } from "src/pages/apps/lineup/components/create-player/create-player";
import { EventDetailsResolver } from "src/pages/event/details/event-details/event-details-resolver";
import { TutorialsComponent } from "src/components/tutorials/tutorials.component";
@NgModule({
    declarations: [
        ResultRanglistListItemComponent,
        CategoryNamePipe,
        TransDatePipe,
        PlanTypePipe,
        TrophyComponent,
        TrophyCustomComponent,
        CountdownComponent,
        ScoreBoardName,
        ScoreBoardBib,
        ScoreBoardWallen,
        ScoreBoardModal,
        ScoreBoardEinzel,
        ResultSearchListItemComponent,
        ResultMenuToolbarComponent,
        RaceByName,
        RaceByBib,
        PopupRegistrationComponent,
        PopoverFeedComponent,
        PaymentComponent,
        ParticipantListComponent,
        MysportSportartListItemComponent,
        MysportProfileListItemComponent,
        MysportIconComponent,
        MyRoutesComponent ,
        MyEventListItemComponent,
        ModalConfigureGeoComponent,
        MenuLayerTotalComponent,
        MenuLayerCategoryComponent,
        LeaderActivity,
        ImageContainerComponent,
        GoogleMapsComponent,
        GoogleAdsComponent,
        EventsBlockWithContainersComponent,
        EventSearchListItemComponent,
        ContainersWithItemsComponent,
        LineChartComponent,
        BibNumberComponent,
        CreateTeamComponent,
        CreatePlayerComponent,
        TutorialsComponent
        
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule,
        TranslateModule,
        // TranslateModule.forRoot({
        //     loader: {
        //         provide: TranslateLoader,
        //         useFactory: (createTranslateLoader),
        //         deps: [HttpClient]
        //     }
        // }),
    ],
    providers:[
        TransDatePipe
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports:[
        RaceByBib,
        PopupRegistrationComponent,
        ResultRanglistListItemComponent,
        TranslateModule,
        CategoryNamePipe,
        TransDatePipe,
        PlanTypePipe,
        TrophyComponent,
        TrophyCustomComponent,
        CountdownComponent,
        ScoreBoardName,
        ScoreBoardBib,
        ScoreBoardWallen,
        ScoreBoardModal,
        ScoreBoardEinzel,
        ResultSearchListItemComponent,
        ResultMenuToolbarComponent,
        RaceByName, 
        PopoverFeedComponent,
        PaymentComponent,
        ParticipantListComponent,
        MysportSportartListItemComponent,
        MysportProfileListItemComponent,
        MysportIconComponent,
        MyRoutesComponent,
        MyEventListItemComponent,
        ModalConfigureGeoComponent,
        MenuLayerTotalComponent,
        MenuLayerCategoryComponent,
        LeaderActivity,
        ImageContainerComponent,
        GoogleMapsComponent,
        GoogleAdsComponent,
        EventsBlockWithContainersComponent,
        EventSearchListItemComponent,
        ContainersWithItemsComponent,
        LineChartComponent,
        BibNumberComponent,
        CreateTeamComponent,
        CreatePlayerComponent,
        TutorialsComponent
        
    ]
  })
  export class SharedModule { }
    export function createTranslateLoader(http: HttpClient) {
        return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }